export default "__VITE_ASSET__4jIOy$eh__"